
// Hamburger Animation
// Hamburger Animation
$( ".js-hamburger" ).click(function() {
  $('body').toggleClass('open')
});


// Mobile Menu

var navTrigger = document.getElementsByClassName('hamburger')[0],
    body = document.getElementsByTagName('body')[0];

navTrigger.addEventListener('click', toggleNavigation);

function toggleNavigation(event) {
  event.preventDefault();
  body.classList.toggle('open');
}





// Smooth Scroll Animation
var scroll = new SmoothScroll('a[href*="#"]');



// QTY Adjust

/* JS Quantity Incrementers */
jQuery(function(){
  var j = jQuery; 
  var addInput = '.js-qty-wrap'; 

  j(addInput).each(function() { 
    var inputEl = j(this).closest(addInput).find('input');
    var n = inputEl.val(); 
    var plusEl = j(this).closest(addInput).find('.plus');
    var minEl = j(this).closest(addInput).find('.min');
    //On plus click add 1 to n
    plusEl.on('click', function(){
      inputEl.val(++n).trigger('change');
    });
    //On min click 
    minEl.on('click', function(){
    //If n is bigger or equal to 1 subtract 1 from n 
      if ( ( inputEl.val() ) > 1) {
        inputEl.val(--n).trigger('change');
      } 
    });
  });
});
	
	
$('.js-blog-carousel').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
	responsive: [     
  {
      breakpoint: 1024,
      settings: {
       	slidesToShow: 3,
   		slidesToScroll: 3,
      }
    },
        {
      breakpoint: 768,
      settings: {
       	slidesToShow: 1,
   		slidesToScroll: 2,
      }
    },
    {
      breakpoint: 600,
        centerMode: true,
		centerPadding: '60px',
      	settings: {
        slidesToShow: 1,
		slidesToScroll: 1,
		dots:true,
		arrows:false,

      }
    }
  ]  	
                                 
});


 
// PDP CAROUSEL WITH THUMBS
  $('.js-slider-primary').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite:true,
    asNavFor: '.js-slider-thumbs'
  });
  $('.js-slider-thumbs').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.js-slider-primary',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    infinite:true,
    variableWidth: false,
    arrows: true,
	prevArrow: "<a href='#' class='previous-arrow'><i class='carousel-arrow carousel-arrow-prev'></i></a>",
  nextArrow: "<a href='#' class='next-arrow'><i class='carousel-arrow carousel-arrow-next'></i></a>",
  });

//  PRESS CAROUSEL
var mobphotos = $(".js-photos-mobile");
mobphotos.each(function() {        
   $(this).slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	dots:true,
	arrows:false});
  });



// Resize functions

function resizeHandler() {
  console.log("window resized");

  if ($(window).width() < 767) {
    console.log("window small than 600");
    
    $('.footer-nav ul').hide();
    $('.footer-nav ul').slideUp(200);
  } else{
     $('.footer-nav ul').show();
     $('.footer-nav-header').removeClass("expanded");
  }
  
  // Megamenu top position 
  var headerHeight = $('#shopify-section-header').outerHeight();
  //console.log("headerHeight = " + headerHeight);
  $('#shopify-section-header .mega-menu').css({'top' : headerHeight + 'px'});
  
}

resizeHandler();

$(window).resize(resizeHandler);

$('body').on('click', '.footer-nav-header', function() { 
  if ($(window).width() < 767) {
    $(this).next().slideToggle(200);
    $(this).toggleClass("expanded");
  }
});



//  COLLECTION CAROUSEL
$(document).ready(function(){
var collection = $(".js-collection-carousel");
collection.each(function() {        
   $(this).slick({
  slidesToShow: 4,
  slidesToScroll: 4,
   centerMode: false,
  appendArrows: $(this).siblings('.collection-carousel-arrows'),
     
  prevArrow: "<button class='previous-arrow'><i class='carousel-arrow carousel-arrow-prev'></i></button>",
  nextArrow: "<button class='next-arrow'><i class='carousel-arrow carousel-arrow-next'></i></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 600,
      centerMode: false,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots:true,
        arrows:false,
      }
    }
  ]
});
  });
  });

//  HOME COLLECTION CAROUSEL
var collection = $(".js-home-collection-carousel");
collection.each(function() {        
   $(this).slick({
  slidesToShow: 3,
  slidesToScroll: 3,
   centerMode: false,
      appendArrows: $(this).siblings('.collection-carousel-arrows'),
  prevArrow: "<button class='previous-arrow'><i class='carousel-arrow carousel-arrow-prev'></i></button>",
  nextArrow: "<button class='next-arrow'><i class='carousel-arrow carousel-arrow-next'></i></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 600,
      centerMode: false,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots:true,
        arrows:false,
      }
    }
  ]
});
  });




//  ARTICLE COLLECTION CAROUSEL -- MOBILE FIRST, UNSLICK ON DESKTOP
var collection = $(".js-article-collection-carousel");
collection.each(function() {        
   $(this).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      dots:true,
      arrows:true,
 
     appendArrows: $(this).siblings('.collection-carousel-arrows'),
      prevArrow: "<button class='previous-arrow'><i class='carousel-arrow carousel-arrow-prev'></i></button>",
      nextArrow: "<button class='next-arrow'><i class='carousel-arrow carousel-arrow-next'></i></button>",
      mobileFirst: true,
      responsive: [
        { // mobileFirst: true | 769 UP
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots:false,
           }
        },
        { // mobileFirst: true |  1023 UP
          breakpoint: 1023,
          settings: "unslick"
        }
      ]
  });
});

// SHOTS CAROUSEL
var shotsCarousel = $(".js-shots-carousel");
shotsCarousel.each(function() {        
   $(this).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    appendArrows: '.shots-carousel-arrows',
    prevArrow: "<button class='previous-arrow'><i class='carousel-arrow carousel-arrow-prev'></i></button>",
    nextArrow: "<button class='next-arrow'><i class='carousel-arrow carousel-arrow-next'></i></button>",
    responsive: [

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        centerMode: false,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:true,
          arrows:false,
        }
      }
    ]
  });
  }); 

//  PRESS CAROUSEL
var collection = $(".js-press");
collection.each(function() {        
   $(this).slick({
  slidesToShow: 1,
  slidesToScroll: 1,
   centerMode: false,
  appendArrows: '.press-carousel-arrows',
  prevArrow: "<button class='previous-arrow'><i class='carousel-arrow carousel-arrow-prev'></i></button>",
  nextArrow: "<button class='next-arrow'><i class='carousel-arrow carousel-arrow-next'></i></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      centerMode: false,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots:true,
        arrows:false,
      }
    }
  ]
});
  });


//  DOCTORS CAROUSEL
var collection = $(".js-doctors-carousel");
collection.each(function() {        
   $(this).slick({
  slidesToShow: 3,
  slidesToScroll: 3,
   centerMode: false,
  appendArrows: '.doctor-carousel-arrows',
  prevArrow: "<button class='previous-arrow'><i class='carousel-arrow carousel-arrow-prev'></i></button>",
  nextArrow: "<button class='next-arrow'><i class='carousel-arrow carousel-arrow-next'></i></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 600,
      centerMode: false,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots:true,
        arrows:false,
      }
    }
  ]
});
  });


//  SINGLE COLLECTION CAROUSEL
  if ($(window).width() > 767) {

var collection = $(".js-single-collection-carousel");
collection.each(function() {        
   $(this).slick({
  slidesToShow: 3,
  slidesToScroll: 3,
   centerMode: false,
 
      appendArrows: $(this).siblings('.collection-carousel-arrows'),
  prevArrow: "<button class='previous-arrow'><i class='carousel-arrow carousel-arrow-prev'></i></button>",
  nextArrow: "<button class='next-arrow'><i class='carousel-arrow carousel-arrow-next'></i></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 600,
      centerMode: false,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots:true,
        arrows:false,
      }
    }
  ]
});
  });

  }




//SWATCH
$(function() {
  $('.swatch :radio').change(function() {
    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    var optionValue = $(this).val();

    var variantID = $(this).parent().data('variant-id');

    $(this)
      .closest('form')
      .find('#productSelect')
      .val(variantID)
      .trigger('change');
  });
});


// PDP TABS

$(document).ready(function() {

  //Set the initial state: highlight the first button...
  $('.tabs').find('li:eq(0)').addClass('active');

  //and hide all tab content except the first one
  $('.tab-content').find('> div:eq(0)').nextAll().hide();

  //actions that apply on click of any of the buttons
  $('.tabs li').click( function(event) {

    //turn off the link so it doesn't try to jump down the page
    event.preventDefault();

    //un-highlight the buttons
    $('.tabs li').removeClass();

    //hide all the slides
    $('.tab-content > div').hide();

    //highlight the current button
    $(this).addClass('active');

    //get the index of the current button...
    var index = $('.tabs li').index(this);

    //and use that index to show the corresponding slide
    $('.tab-content > div:eq('+index+')').show();

  });

});
 


// newsletter form submission to klaviyo
var $contact_form_agreement = $('.klaviyo-custom--form .klaviyo_form_agreement input');
$contact_form_agreement.each( function() {
  
  $(this).on("click", function() { 
  	
    if ( $(this).prop("checked") == true ) {
      
      $(this).parent().parent().find(".kl_subscribe").removeAttr("disabled");
      
    } else {
      
      $(this).parent().parent().find(".kl_subscribe").attr("disabled", "disabled");
      
    }
  
  } );
  
} );


var $contact_form = $('.klaviyo-custom--form .kl_subscribe');
$contact_form.each(function() {
    $(this).on('click', function(e) {
        e.preventDefault();
      
      	let email_address = $(this).parent().find("#email").val();
      	let kl_id = $(this).parent().find("#list_id").val();
      
      successCallback = function ( el ) {
      	$(el).parent().append("<p id='success' style='color: green; font-weight: 700; font-family: Montserrat,sans-serif; font-size: 18px; margin: 10px 0;'>Your email address successfully submitted! Please check your email for furthur instructions.</p>");
        $(el).parent().find("#email").val(" ");
        $(el).parent().find(".klaviyo_form_agreement input").prop("checked", false);
        $(el).parent().find(".kl_subscribe").attr("disabled", "disabled");
        
        setTimeout( function() {
        	$(el).parent().find("#success").remove();
        }, 2000)
      }
      
      if ( email_address != "" ) {
        let data = {};
        data['g'] = kl_id;
        data['email'] = email_address;
        let settings = {
          method: "POST",
          url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
          async: true,
          crossDomain: true,
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            "cache-control": "no-cache"
          },
          data: data,
          success: successCallback($(this))
        };
        $.ajax(settings);
      } else {
      	alert("Please enter your email address");
      } 
      

      	
    });
});